import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@components/atoms/badge';
import { Loader } from '@components/atoms/loader';
import { BadgeStatusEnum } from '@models/enums';
import type { ZkProof } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/finish/types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

type ZkProofBlockProps = {
    isWeb3?: boolean;
    isLoading: boolean;
    verified?: boolean;
    zkProof?: ZkProof;
    zkProofError: string;
};

export const ZkProofBlock: React.FC<ZkProofBlockProps> = ({
    isWeb3,
    isLoading,
    verified,
    zkProof,
    zkProofError,
}) => {
    const { t } = useTranslation();

    if (!isWeb3) {
        return null;
    }

    return (
        <Stack
            direction='column'
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {isLoading && (
                <Box
                    sx={{
                        padding: '26px',
                    }}
                >
                    <Loader text={t('docVerificationWidget.finish.verificationInProgress')} />
                </Box>
            )}
            {!isLoading &&
                (verified && zkProof ? (
                    <Box
                        sx={{
                            bgcolor: '#f6f8fa',
                            padding: '12px',
                            borderRadius: '6px',
                            fontSize: '10px',
                            height: '400px',
                            overflow: 'auto auto',
                            whiteSpace: 'pre',
                            width: '100%',
                        }}
                    >
                        {JSON.stringify(zkProof, null, 2)}
                    </Box>
                ) : (
                    zkProofError && (
                        <Badge text={zkProofError} size='s' status={BadgeStatusEnum.ERROR} />
                    )
                ))}
        </Stack>
    );
};
